<ng-container *transloco="let t">
  <div class="my-2 flex justify-end">
    <IButton [label]="t('common.restore_columns')" color="white" size="sm" (onClick)="restoreColumns()" />
  </div>
  <div class="ag-theme-quartz">
    <ag-grid-angular
      style="width: 100%; height: 75vh"
      [rowData]="gridData!"
      [gridOptions]="gridOptions"
      [statusBar]="STATUS_BAR"
    />
  </div>
</ng-container>
